import {
  ADD_TRADE_AGREEMENT_VALIDATOR_REQUEST,
  ADD_TRADE_AGREEMENT_VALIDATOR_SUCCESS,
  ADD_TRADE_AGREEMENT_VALIDATOR_FAIL,
} from '../actions/addTradeAgreementValidator';

const initialState = {
  loading: false,
};

const addTradeAgreementValidatorReducer = (state = initialState, action) => {
  const { type } = action;
  //const { validators, counter } = state;
  switch (type) {
    case ADD_TRADE_AGREEMENT_VALIDATOR_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case ADD_TRADE_AGREEMENT_VALIDATOR_SUCCESS:
    case ADD_TRADE_AGREEMENT_VALIDATOR_FAIL:
      return {
        ...state,
        loading: false,
      };

    default:
      return state;
  }
};

export default addTradeAgreementValidatorReducer;
